const cacheControlInterceptor = (config)=>{
    // Avoid Varnish, CDN caching response
    if (!!config.apiRegExpNoCacheHeaders && config.url.match(config.apiRegExpNoCacheHeaders)) {
        config.headers['Cache-Control'] = 'private';
    } else {
        config.headers['Cache-Control'] = process.env.NEXT_PUBLIC_BH_CACHE_CONTROL_HEADER;
    }
    return config;
};

export { cacheControlInterceptor };
